/* eslint-disable jsx-a11y/no-onchange */
/* eslint-env browser */
import React, { useState, useContext } from 'react';

import responsiveContext from 'Components/utils/responsive/responsiveContext';
import appConfig from 'Config';
import { isStrictlyDevelopmentEnv } from 'Utils/context/contextUtils';

export const EasyTesting = () => {
  const [currentDirection, setCurrentDirection] = useState('ltr');
  const [isVisible, setIsVisible] = useState(false);
  const responsive = useContext(responsiveContext);

  const handleDirectionChange = event => {
    const newDirection = event.target.value;

    setCurrentDirection(newDirection);

    // $FlowFixMe
    const docEl: DocumentElement = document.documentElement;
    docEl.classList.remove('ltr', 'rtl');
    docEl.classList.add(newDirection);
    docEl.dir = newDirection;
    // $FlowFixMe
    document.body.dir = newDirection;
  };

  const handleVisibilityChange = () => {
    setIsVisible(!isVisible);
  };

  // don't render on server and initial boot. Fixes some weird SSR problems
  if (!isStrictlyDevelopmentEnv(appConfig) || !responsive.isAppMounted) {
    return null;
  }

  const easyTestingStyle = {
    position: 'fixed',
    zIndex: 300,
    top: '210px',
    left: '10px',
    transform: 'rotateZ(-90deg)',
    WebkitTransform: 'rotateZ(-90deg)',
    transformOrigin: 'top left',
    WebkitTransformOrigin: 'top left',
    width: isVisible ? 'auto' : '25px',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    direction: 'ltr',
  };
  const directionStyle = {
    margin: '0 3px',
    borderWidth: '3px',
    borderStyle: 'solid',
    borderColor: currentDirection === 'ltr' ? 'green' : 'red',
    width: '80px',
    verticalAlign: 'middle',
    outline: 0,
  };
  const visibilityStyle = {
    border: 0,
    padding: 0,
    margin: '0 3px 0',
    verticalAlign: 'middle',
    background: 'transparent',
    outline: 0,
  };
  const switchVisibilityStyle = {
    fontSize: 0,
    display: 'block',
    border: '2px solid rgba(0, 0, 0, 0.4)',
    width: '20px',
    height: '20px',
    backgroundColor: isVisible ? 'red' : 'yellow',
    borderRadius: '10px',
    transition: 'background-color ease-out 0.7s',
  };

  return (
    <div className="easyTesting" style={easyTestingStyle}>
      <button onClick={handleVisibilityChange} style={visibilityStyle} type="button">
        <span style={switchVisibilityStyle}>x</span>
      </button>
      <label className="a11y" htmlFor="switchRTL">
        Switch
      </label>
      <select
        id="switchRTL"
        onChange={handleDirectionChange}
        style={directionStyle}
        value={currentDirection}
      >
        <option value="ltr">L→R</option>
        <option value="rtl">R→L</option>
      </select>
    </div>
  );
};
